var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glance"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.header.label)+" - "+_vm._s(_vm.displayHeader))])]),_vm._v(" "),_c('detail-card',{attrs:{"layout":_vm.layout,"detail-body":_vm.glanceData,"editable":[],"keep-card-container":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71cb3e20","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Glance.vue
// module id = 779
// module chunks = 0